import React from 'react';
import LandingPageTemplate from '../../components/LandingPageTemplate';
import {
  AllInclusive as AllInclusiveIcon,
  ShowChart as ChartIcon,
  Savings as SavingsIcon,
  Build as BuildIcon,
} from '@mui/icons-material';
import heroImage from '../../assets/images/hpe_servers/hpe-proliant-dl380-gen11.png';

const NutanixLanding: React.FC = () => {
  return (
    <LandingPageTemplate
      headline="Build Your Private Cloud with Nutanix"
      subheadline="Hyperconverged infrastructure that delivers cloud simplicity with on-premises control and security."
      heroImage={heroImage}
      ctaText="Get a Quote"
      valueProps={[
        'Simplified Infrastructure',
        'Cloud-Like Experience',
        'Predictable Performance',
        'Lower TCO',
        'Fast Deployment',
        'Built-in Disaster Recovery',
      ]}
      features={[
        {
          title: 'Hyperconverged Infrastructure (HCI)',
          description:
            'Combine compute, storage, and virtualization in a single platform. Eliminate infrastructure silos and reduce complexity by up to 60%.',
          icon: <AllInclusiveIcon />,
        },
        {
          title: 'One-Click Operations',
          description:
            'Deploy and manage your entire infrastructure with intuitive, cloud-like simplicity. Reduce management time and eliminate specialized skills requirements.',
          icon: <BuildIcon />,
        },
        {
          title: 'Linear Scalability',
          description:
            'Start small and grow seamlessly. Add nodes incrementally as your needs grow without performance degradation or downtime.',
          icon: <ChartIcon />,
        },
        {
          title: 'Native Data Protection',
          description:
            'Built-in backup, replication, and disaster recovery. Protect your data without third-party tools or additional complexity.',
          icon: <SavingsIcon />,
        },
      ]}
      stats={[
        { value: '60%', label: 'TCO Reduction' },
        { value: '20K+', label: 'Global Customers' },
        { value: '1-Click', label: 'Deployment' },
        { value: '5X', label: 'Faster Provisioning' },
      ]}
      ctaHeadline="Ready to Deploy Nutanix?"
      ctaDescription="Get a quote and ROI analysis from TNCOSOFT's Nutanix certified architects."
      primaryColor="#024DA1"
      accentColor="#012A5E"
    />
  );
};

export default NutanixLanding;
